module.exports = __webpack_public_path__ + "img/ZHWLRJKF_6 - 副本.e8801737.jpg";